import React from 'react';
import { Button } from './ui/Button';
import { Download, Globe } from 'lucide-react';
export function TopBar() {
  return <div className="bg-[#2B0A3D] text-white py-2 px-4 sticky top-0 z-50 shadow-md" data-id="element-190">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-2 text-xs sm:text-sm" data-id="element-191">
        <div className="flex items-center gap-4 text-center sm:text-left opacity-90" data-id="element-192">
          <span className="flex items-center gap-1" data-id="element-193">
            <Download className="w-3 h-3" data-id="element-194" /> Acceso inmediato
          </span>
          <span className="hidden sm:inline" data-id="element-195">•</span>
          <span className="hidden sm:inline" data-id="element-196">PDF descargable</span>
          <span className="hidden sm:inline" data-id="element-197">•</span>
          <span className="flex items-center gap-1" data-id="element-198">
            <Globe className="w-3 h-3" data-id="element-199" /> Funciona vivas donde vivas
          </span>
        </div>
        <Button href="#oferta" variant="primary" size="sm" className="py-1 h-8 text-xs font-bold uppercase tracking-wider hidden sm:inline-flex" data-id="element-200">
          Comprar ahora
        </Button>
      </div>
    </div>;
}